import { createSvg, SVGIcon } from '@amzn/atoz-web/Icons';
export var VtoIcon = createSvg('VtoIcon', // name
new SVGIcon([
    // paths
    'M11.619 1.169C5.775 1.169 1.03 5.912 1.03 11.756c0 5.844 4.744 10.588 10.588 10.588 5.843 0 10.587-4.744 10.587-10.588 0-5.844-4.744-10.587-10.587-10.587m0 22.206C5.225 23.375 0 18.15 0 11.756S5.225.137 11.619.137c6.393 0 11.619 5.225 11.619 11.62 0 6.393-5.226 11.618-11.62 11.618',
    'm15.4 16.431-4.331-3.025V6.737h1.1v6.119l3.85 2.75z'
], { viewBox: '0 0 24 25' }, // params
32, 32));
